import { forwardRef, type InputHTMLAttributes } from 'react'

import { cn } from '@/utils/cn'

import { baseControl } from './styles'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(baseControl, invalid ? 'border-critical' : 'border-line', className)}
      {...props}
    />
  )
})
